module.exports = __webpack_public_path__ + "static/media/equipe-alexandre-avatar@2x.84500a6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/sass/images/equipe/equipe-alexandre-avatar@2x.png
// module id = 193
// module chunks = 0